module.exports = __webpack_public_path__ + "static/media/pitch-icon.32609f8e.svg";